import { convertToFormData } from 'helper/convert_obj_to_form_data';
import client from './config'

//////////////// advice ////////////////
const url = 'advice';
export const getAdviceDataRequest = () => client.get(url);

export const updateAdviceDataRequest = (values, onUploadProgress) => {
    return client.post(`${url}?_method=put`, convertToFormData(values), {
        onUploadProgress: (progress) =>
          onUploadProgress((progress.loaded / progress.total) * 100),
      });
}